// inspired by https://github.com/stadline/svg-flatten/blob/master/src/pathify.js
import utils from './index'

function _convertPoints(points) {
  var path = "";

  for (var i = 0; i < points.length; i += 2) {
    var prefix = path.length ? ' ' : 'M';
    path += prefix + points[i] + ',' + points[i + 1];
  }

  return path;
}

function wrap(svgString) {
  let div = document.createElement("div")
  div.innerHTML = `<svg>${svgString}</svg>`
  return div.firstChild
}

function getCTM(el) {
  let ctm
  for (let p = el; p; p = p.parentNode) {
    if (ctm) {
      ctm = getCTMofEl(el).inverse().multiply(ctm)
    } else {
      ctm = getCTMofEl(el)
    }
  }
  return ctm
}

function getCTMofEl(el) {
  let ctm = el.getCTM()
  if (ctm) {
    return ctm
  }

  let tr = el.transform.baseVal

  for (let i = 0; i < tr.length; i++) {
    if (ctm) {
      ctm = tr[i].matrix
    } else {
      ctm = tr[i].matrix.inverse().multiply(ctm)
    }
  }
  return ctm
}

export default function (svgString) {
  let root = wrap(svgString)
    ,treeWalker
    //, treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, null, false)
    , node
    , attrs
    , pathCode = ""
    , paths = ""
    , ctm;
  try{
    //国产化firefox需要这个
    treeWalker = document.createTreeWalker(root)
  }catch(e){
    //ie需要这个
    treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, null, false)
  }
  while (treeWalker.nextNode()) {
    node = treeWalker.currentNode
    attrs = utils.attr(node)

    switch (node.nodeName.toLowerCase()) {
      case "rect": {
        attrs.x = (+ attrs.x) || 0
        attrs.y = (+ attrs.y) || 0
        attrs.rx = (+ attrs.rx) || 0
        attrs.ry = (+ attrs.ry) || 0
        attrs.width = (+ attrs.width) || 0
        attrs.height = (+ attrs.height) || 0
        pathCode = `
          M ${attrs.x} ${attrs.y + attrs.ry}
          A ${attrs.rx} ${attrs.ry}, 0, 0, 1, ${attrs.rx + attrs.x} ${attrs.y}
          L ${attrs.x + attrs.width - attrs.rx} ${attrs.y}

          A ${attrs.rx} ${attrs.ry}, 0, 0, 1, ${attrs.x + attrs.width} ${attrs.y + attrs.ry}

          L ${attrs.x + attrs.width} ${attrs.y + attrs.height - attrs.ry}

          A ${attrs.rx} ${attrs.ry}, 0, 0, 1, ${attrs.x + attrs.width - attrs.rx} ${attrs.y + attrs.height}

          L ${attrs.x + attrs.rx} ${attrs.y + attrs.height}

          A ${attrs.rx} ${attrs.ry}, 0, 0, 1, ${attrs.x} ${attrs.y + attrs.height - attrs.ry}

          Z
        `

        // Quadratic Bezier Curves version
        pathCode = `
          M ${attrs.x} ${attrs.y + attrs.ry}
          Q ${attrs.x} ${attrs.y}, ${attrs.x + attrs.rx} ${attrs.y}
          L ${attrs.x + attrs.width - attrs.rx} ${attrs.y}
          Q ${attrs.x + attrs.width} ${attrs.y}, ${attrs.x + attrs.width} ${attrs.y + attrs.ry}
          L ${attrs.x + attrs.width} ${attrs.y + attrs.height - attrs.ry}
          Q ${attrs.x + attrs.width} ${attrs.y + attrs.height}, ${attrs.x + attrs.width - attrs.rx} ${attrs.y + attrs.height}
          L ${attrs.x + attrs.rx} ${attrs.y + attrs.height}
          
          Q ${attrs.x} ${attrs.y + attrs.height}, ${attrs.x} ${attrs.y + attrs.height - attrs.ry}
          
          Z
        `
        break
      }

      case "circle": {
        attrs.cx = (+ attrs.cx) || 0
        attrs.cy = (+ attrs.cy) || 0
        attrs.r = (+ attrs.r) || 0
        pathCode = `
          M ${attrs.cx} ${attrs.cy - attrs.r}
          A ${attrs.r} ${attrs.r}, 0, 1, 0, ${attrs.cx} ${attrs.cy + attrs.r}
          A ${attrs.r} ${attrs.r}, 0, 1, 0, ${attrs.cx} ${attrs.cy - attrs.r}
          Z
        `
        // 4 cubic Bézier Curves //http://spencermortensen.com/articles/bezier-circle/
        // P_0 = (0,1), P_1 = (c,1), P_2 = (1,c), P_3 = (1,0)
        // P_0 = (1,0), P_1 = (1,-c), P_2 = (c,-1), P_3 = (0,-1)
        // P_0 = (0,-1), P_1 = (-c,-1), P_3 = (-1,-c), P_4 = (-1,0)
        // P_0 = (-1,0), P_1 = (-1,c), P_2 = (-c,1), P_3 = (0,1)
        // with c = 0.551915024494.
        let { cx, cy, r } = attrs, c = 0.551915024494 * r
        pathCode = `
          M ${cx} ${cy - r} C ${cx + c} ${cy - r}, ${cx + r} ${cy - c}, ${cx + r} ${cy}
          C ${cx + r} ${cy + c}, ${cx + c} ${cy + r}, ${cx} ${cy + r}
          C ${cx - c} ${cy + r}, ${cx - r} ${cy + c}, ${cx - r} ${cy}
          C ${cx - r} ${cy - c}, ${cx - c} ${cy - r}, ${cx} ${cy - r}
          Z
        `
        break
      }
      case "ellipse": {
        attrs.cx = (+ attrs.cx) || 0
        attrs.cy = (+ attrs.cy) || 0
        attrs.rx = (+ attrs.rx) || 0
        attrs.ry = (+ attrs.ry) || 0
        pathCode = `
        M ${attrs.cx} ${attrs.cy - attrs.r}
        A ${attrs.rx} ${attrs.ry}, 0, 1, 0, ${attrs.cx} ${attrs.cy + attrs.ry}
        A ${attrs.rx} ${attrs.ry}, 0, 1, 0, ${attrs.cx} ${attrs.cy - attrs.ry}
        Z
      `
        break
      }
      case "polygon": {
        pathCode = _convertPoints(attrs.points.trim().split(/[\s,]+/)) + "z"
        break
      }
      case "line": {
        pathCode = _convertPoints([attrs.x1, attrs.y1, attrs.x2, attrs.y2])
        break
      }
      case "polyline": {
        pathCode = _convertPoints(attrs.points.trim().split(/[\s,]+/))
        break
      }
    }

    if (pathCode) {
      ctm = getCTM(node)
      if (ctm) {
        // @ts-ignore
        paths += Snap.path.map(pathCode, Snap.matrix(
          ctm.a,
          ctm.b,
          ctm.c,
          ctm.d,
          ctm.e,
          ctm.f,
        ))
      } else {
        // @ts-ignore
        paths += pathCode
      }

    }
  }

  return paths
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/utils/transformShape2path.js